import * as React from 'react';
import { cn } from '@common/bw-ui/lib/utils';
import { Stepper } from '@common/bw-ui/ui/stepper';
import { CheckoutFlowHeader } from './CheckoutFlowHeader';
import { CHECKOUT_FLOW_STEPS } from './constants';

export interface BasketLayoutProps {
  activeStep?: number;
  className?: string;
  children: React.ReactNode;
  headerChildren?: React.ReactNode;
}

export function BasketLayout({
  activeStep = 0,
  className,
  children,
  headerChildren,
}: BasketLayoutProps) {
  return (
    <div
      data-slot="basket-page"
      className={cn('tw:min-h-screen tw:bg-secondary', className)}
    >
      <CheckoutFlowHeader>{headerChildren}</CheckoutFlowHeader>

      <div className="tw:px-4 tw:md:px-8 tw:lg:px-16 tw:py-6 tw:md:py-8">
        <Stepper
          steps={CHECKOUT_FLOW_STEPS}
          activeStep={activeStep}
          className="tw:max-w-6xl tw:mx-auto"
        />
      </div>

      <main className="tw:px-4 tw:md:px-8 tw:lg:px-16 tw:pb-6 tw:md:pb-8">
        <div className="tw:max-w-6xl tw:mx-auto tw:grid tw:grid-cols-1 tw:lg:grid-cols-[1fr_360px] tw:gap-6 tw:lg:gap-8">
          {children}
        </div>
      </main>
    </div>
  );
}
